export enum pageStates {
  addCard = "addCard",
  displayCards = "displayCards",
  selectedCard = "selectedCard",
  hidden = "hidden",
  forceAddCard = "forceAddCard",
}

export enum autoRenewOptInCountries {
  us = "United States",
}

export const autoRenewOptInUSStates = ["California", "Vermont", "New York"];
